<script>
import { OFFER_TYPE_SIMPLE   } from '../model/offer';
import { OFFER_TYPE_PERSONAL } from '../model/offer';

import PlayerOfferSimple   from './PlayerOfferSimple.vue';
import PlayerOfferPersonal from './PlayerOfferPersonal.vue';
import PlayerOfferPersonalSuperWhale from './PlayerOfferPersonalSuperWhale.vue';

export default {
  name: 'PlayerOffer',

  props: {
    offer: {
      type: Object,
      required: true,
    },
  },

  render(createElement) {
    const componentType = getComponentTypeForOffer(this.offer);
    const data = {
      props: {
        offer: this.offer,
      },
    };
    return createElement(componentType, data);
  },
};

function getComponentTypeForOffer(offer) {
  switch(offer.type) {
    case OFFER_TYPE_SIMPLE:
      return PlayerOfferSimple;

    case OFFER_TYPE_PERSONAL:
      return getComponentTypeForPersonalOffer(offer);
  }
  return null;
}

function getComponentTypeForPersonalOffer(offer) {
  // @marketing/offer/for_you/super_whale
  const SUPER_WHALE_OFFER_PROTO_ID = 79644315;

  if(offer.protoId === SUPER_WHALE_OFFER_PROTO_ID) {
    return PlayerOfferPersonalSuperWhale;
  }

  return PlayerOfferPersonal;
}
</script>
